import {
  BarcodeOutlined,
  FileTextOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import { Modal, Space } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import Barcode from 'react-barcode';
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import { generateBill } from '../pdf/generateBill';
import { generateTransactionBill } from '../pdf/generateTransactionBill';
import { PrintFormatRenderer } from '@/features/format-designer/PrintFormatRenderer';
import { getPrintFormatFromTemplate } from '@/utils/transaction/jewelry-new-sticker/buildBillTemplatePayload';
import { BillPrintMapper } from '@/utils/transaction/jewelry-new-sticker/mapper/bill';
import {
  mapAppToBusiness,
  mapRawSummaryToTokenContext,
  mapVoucherPrintToTokenContext,
} from '@/shared/utils/invoiceMapper';
import useAppData from '@/hooks/useAppData';
import { useUpdateApi, useUpdateApiNoToast } from '@/apiError/apiUpdate';

const TransactionSubmitModal = ({
  visible,
  onClose,
  onGenerateBill,
  onSave,
  barcodeValues = [],
  formReport,
  hideBarCode = false,
  tableData = [],
  columns = [],
  date,
  title,
  voucherNumber,
  paidTo,
  totalDrAmount,
  totalCrAmount,
  from = '',
  party,
  billNumber,
  navigate = () => {},
  extraDetails,
  setExtraDetails,
  billTemplateData,
  voucherPrintData,
}) => {
  const ref = useRef();
  const isVoucher = from !== 'transaction';
  const { app } = useAppData();
  const [dataToPut, setDataToPut] = useState();
  // const pageStyle = `
  //   @page {
  //         size: 100mm 13mm;
  //         margin: 0;
  //       }
  //       @media print {
  //       body {
  //           margin: 0;
  //           padding: 0;
  //         }
  //       barcode-container {
  //             height: 100%;
  //         }
  //         .barcode-details {
  //           margin-left: 30mm;
  //           display: flex;
  //           width: 70mm;
  //           height: 13mm;
  //         }
  //         .barcode-item {
  //           display: inline-flex;
  //           flex-direction: column;
  //           align-items: center;
  //           justify-content: center;
  //           width: auto;
  //           height: 13mm;
  //           /*margin-left: 66mm;*/
  //           page-break-inside: avoid;
  //           gap: 0.5px;
  //         }
  //         .barcode-secondItem {
  //           width: 40%;
  //           display: flex;
  //           flex-direction: column;
  //           /* column-gap: 5px; */
  //           margin-left: -10mm;
  //           /* grid-template-columns: 80% 80%; */
  //           /* gap: 2px; */
  //           align-self: center;
  //         }
  //       }
  //   `;

  const pageStyle = ``;

  const { mutate: incrementPrint } = useUpdateApiNoToast();

  useEffect(() => {
    const fetchDataById = async (referenceId) => {
      if (referenceId) {
        const response = await ShowDataById.getDataById(
          `/account/ledger/${referenceId}/`,
          navigate,
        );
        setDataToPut(response?.data);
      }
    };
    fetchDataById(billNumber?.ledgerId);
  }, [billNumber]);

  const componentRef = useRef(null);

  const handleOnBeforeGetContent = useCallback(() => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 10);
    });
  }, []);

  const handleBeforePrint = useCallback(() => {});

  const printTemplate = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: '\u00A0',
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    removeAfterPrint: true,
  });

  return (
    <Modal
      title="Transaction Options"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
    >
      <div
        style={{
          display: 'none',
        }}
      >
        {formReport ? (
          <div ref={ref} className="barcode-container">
            <div className="barcode-item">
              <p
                style={{
                  textAlign: 'center',
                  fontSize: '8px',
                  fontWeight: 'bold',
                  marginTop: '10px',
                  color: 'black',
                }}
              >
                Jwellery Management System
              </p>
              <Barcode
                fontSize={12}
                value={barcodeValues}
                format="CODE128"
                width={0.9}
                height={18}
              />
            </div>
          </div>
        ) : (
          <div ref={ref} className="barcode-container">
            {barcodeValues?.length > 0 ? (
              barcodeValues.map((value, index) => (
                <div key={index} className="barcode-item">
                  <p
                    style={{
                      textAlign: 'center',
                      fontSize: '8px',
                      fontWeight: 'bold',
                      marginTop: '10px',
                      color: 'black',
                    }}
                  >
                    Jwellery Management System
                  </p>

                  {/* <Barcode
                    fontSize={12}
                    value={value}
                    format="CODE128"
                    width={0.9}
                    height={18}
                  /> */}
                </div>
              ))
            ) : (
              <div>No barcodes to print</div>
            )}
          </div>
        )}
      </div>

      <Space
        direction="horizontal"
        style={{
          width: '100%',
          justifyContent: 'space-around',
        }}
      >
        {hideBarCode ? (
          ''
        ) : (
          <ReactToPrint
            pageStyle={pageStyle}
            content={() => ref.current} // Reference the container with all barcodes
            trigger={() => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  transition: 'all 0.3s',
                  cursor: 'pointer',
                }}
              >
                <div
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: '50%',
                    backgroundColor: 'brown',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <BarcodeOutlined style={{ color: 'white', fontSize: 24 }} />
                </div>
                <span>Print Barcodes</span>
              </div>
            )}
          />
        )}

        {formReport ? (
          ''
        ) : (
          <>
            {!isVoucher && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  transition: 'all 0.3s',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  from === 'transaction'
                    ? generateTransactionBill(
                        tableData,
                        columns,
                        date,
                        title,
                        voucherNumber,
                        party,
                        billNumber,
                        dataToPut,
                        extraDetails,
                      )
                    : generateBill(
                        tableData,
                        columns,
                        date,
                        title,
                        voucherNumber,
                        paidTo,
                        totalDrAmount,
                        totalCrAmount,
                      )
                }
              >
                <div
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: '50%',
                    backgroundColor: '#1890ff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <FileTextOutlined style={{ color: 'white', fontSize: 24 }} />
                </div>
                <span>Generate Bill</span>
              </div>
            )}
            <div>
              <div className="tw-flex tw-flex-col tw-items-center tw-space-y-2">
                <div
                  className="tw-w-24 tw-h-24 tw-rounded-full tw-bg-blue-600 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-shadow-lg hover:tw-bg-blue-700 tw-transition-all tw-duration-300"
                  onClick={() => {
                    if (extraDetails?.customerDetails?.referenceId) {
                      incrementPrint({
                        url: `/transaction/sales/${extraDetails?.customerDetails?.referenceId}/increment-print/`,
                      });
                    }
                    printTemplate();
                  }}
                >
                  <FileTextOutlined className="tw-text-white tw-text-3xl" />
                </div>
                <span className="tw-text-sm tw-font-medium tw-text-gray-700">
                  {isVoucher ? 'Print Voucher' : 'Generate Bill (By Template)'}
                </span>
              </div>
            </div>
            {/* <div
              onClick={navigate}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                transition: 'all 0.3s',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  width: 100,
                  height: 100,
                  borderRadius: '50%',
                  backgroundColor: '#52c41a',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <SaveOutlined style={{ color: 'white', fontSize: 24 }} />
              </div>
              <span>Save Transaction</span>
            </div> */}
          </>
        )}
      </Space>

      {(() => {
        const printFormat = getPrintFormatFromTemplate(
          billTemplateData?.editorConfig,
          billTemplateData?.configuration,
        );
        if (printFormat) {
          return (
            <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
              <PrintFormatRenderer
                ref={componentRef}
                printFormat={printFormat}
                tokenCtx={
                  voucherPrintData
                    ? mapVoucherPrintToTokenContext(
                        voucherPrintData,
                        mapAppToBusiness(app),
                      )
                    : mapRawSummaryToTokenContext(
                        extraDetails?.summaryData,
                        extraDetails?.detailsData,
                        mapAppToBusiness(app),
                        extraDetails?.goldRateInTola,
                        extraDetails?.silverRateInTola,
                      )
                }
              />
            </div>
          );
        }
        if (
          billTemplateData?.editorConfig &&
          billTemplateData?.contentBlocks?.length
        ) {
          return (
            <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
              <BillPrintMapper
                ref={componentRef}
                data={extraDetails}
                blocks={billTemplateData.contentBlocks}
                editorConfig={billTemplateData.editorConfig}
                copies={[]}
                isHidden={false}
              />
            </div>
          );
        }
        return null;
      })()}
    </Modal>
  );
};

export default TransactionSubmitModal;
